// ('APTRANSCO',)
// ('Arunachal Ben',)
// ('Assam Ben',)
// ('BSPHCL',)
// ('CHANDIGARH',)
// ('CSEB Beneficiary',)
// ('DELHI',)
// ('DNHDDPDCL',)
// ('DVC',)
// ('GEB Beneficiary',)
// ('GOA Beneficiary',)
// ('HARYANA',)
// ('HP',)
// ('JHARKHAND',)
// ('JK&LADAKH',)
// ('KPTCL',)
// ('KSEB',)
// ('MPSEB Beneficiary',)
// ('MSEB Beneficiary',)
// ('Meghalaya Ben',)
// ('Mizoram Ben',)
// ('NEPAL ELECTRICITY AUTHORITY MUZAFFARPUR',)
// ('NEPAL ELECTRICITY AUTHORITY TANAKPUR',)
// ('Nagaland Ben',)
// ('ODISHA',)
// ('PUNJAB',)
// ('RAJASTHAN',)
// ('SIKKIM',)
// ('TSTRANSCO',)
// ('Tamil Nadu Electricity Board',)
// ('Tripura Ben',)
// ('UPPCL',)
// ('UTTARAKHAND',)
// ('WBSETCL',)
// ('North Central Railway Prayagraj',)
// ('GOA SR',)
// ('Manipur Ben',)
// ('PONDY',)

export const DISCOM_LIST = [
  "All",
  "APTRANSCO",
  "Arunachal Ben",
  "Assam Ben",
  "BSPHCL",
  "CHANDIGARH",
  "CSEB Beneficiary",
  "DELHI",
  "DNHDDPDCL",
  "DVC",
  "GEB Beneficiary",
  "GOA Beneficiary",
  "HARYANA",
  "HP",
  "JHARKHAND",
  "JK&LADAKH",
  "KPTCL",
  "KSEB",
  "MPSEB Beneficiary",
  "MSEB Beneficiary",
  "Meghalaya Ben",
  "Mizoram Ben",
  "NEPAL ELECTRICITY AUTHORITY MUZAFFARPUR",
  "NEPAL ELECTRICITY AUTHORITY TANAKPUR",
  "Nagaland Ben",
  "ODISHA",
  "PUNJAB",
  "RAJASTHAN",
  "SIKKIM",
  "TSTRANSCO",
  "Tamil Nadu Electricity Board",
  "Tripura Ben",
  "UPPCL",
  "UTTARAKHAND",
  "WBSETCL",
  "North Central Railway Prayagraj",
  "GOA SR",
  "Manipur Ben",
  "PONDY",
];
